module.exports = __webpack_public_path__ + "static/media/index-2.ca2a449e.mp4";